export enum AdminActionsEnum {
  ADMIN_GET_USER_ADMIN_URL = 'ADMIN_GET_USER_ADMIN_URL',
  ADMIN_SET_USER_ADMIN_URL = 'ADMIN_SET_USER_ADMIN_URL',
  ADMIN_GET_FETCH_SETTINGS = 'ADMIN_GET_FETCH_SETTINGS',
  ADMIN_GET_FETCH_SETTINGS_SUCCESS = 'ADMIN_GET_FETCH_SETTINGS_SUCCESS',
  ADMIN_SET_FETCH_SETTINGS = 'ADMIN_SET_FETCH_SETTINGS',
  ADMIN_UPDATE_SETTINGS = 'ADMIN_UPDATE_SETTINGS',
  ADMIN_UPDATE_SETTINGS_SCHEDULE = 'ADMIN_UPDATE_SETTINGS_SCHEDULE',
  ADMIN_GET_CATALOGS_FOR_UPDATE = 'ADMIN_GET_CATALOGS_FOR_UPDATE',
  ADMIN_SET_CATALOGS_FOR_UPDATE = 'ADMIN_SET_CATALOGS_FOR_UPDATE',
  ADMIN_UPLOAD_CATALOGS = 'ADMIN_UPLOAD_CATALOGS',
  ADMIN_SET_CATALOG_NAME = 'ADMIN_SET_CATALOG_NAME',
  ADMIN_GET_CATALOG_TYPES = 'ADMIN_GET_CATALOG_TYPES',
  ADMIN_CREATE_CATALOG_TYPES = 'ADMIN_CREATE_CATALOG_TYPES',
  ADMIN_UPDATE_CATALOG_TYPES = 'ADMIN_UPDATE_CATALOG_TYPES',
  ADMIN_UPDATE_FRGU = 'ADMIN_UPDATE_FRGU',
  ADMIN_GET_NEWS = 'ADMIN_GET_NEWS',
  ADMIN_GET_NEWS_NEXT_PAGE = 'ADMIN_GET_NEWS_NEXT_PAGE',
  ADMIN_SET_NEWS = 'ADMIN_SET_NEWS',
  ADMIN_SET_NEWS_ORDER = 'ADMIN_SET_NEWS_ORDER',
  ADMIN_CATALOGS_EXPORTS_SUBMIT = 'ADMIN_CATALOGS_EXPORTS_SUBMIT',
  ADMIN_GET_SISTEM_INOPERABILITY_LIST = 'ADMIN_GET_SISTEM_INOPERABILITY_LIST',
  ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE = 'ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST_SHOW_SAVE = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST_SHOW_SAVE',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST_DISABLE_SAVE = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST_DISABLE_SAVE',
  ADMIN_SET_SISTEM_INOPERABILITY_LIST_ADD_RECORD = 'ADMIN_SET_SISTEM_INOPERABILITY_LIST_ADD_RECORD',
  ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_REF = 'ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_REF',
  ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_ELEMENT_REF = 'ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_ELEMENT_REF',
  ADMIN_SET_SISTEM_INOPERABILITY_FORM_UNSAVED_RECORDS = 'ADMIN_SET_SISTEM_INOPERABILITY_FORM_UNSAVED_RECORDS',
  ADMIN_GET_SMEV_RESEND_BY_SENDING_DATE = 'ADMIN_GET_SMEV_RESEND_BY_SENDING_DATE',
  ADMIN_GET_SMEV_RESEND_BY_SENDING_DATE_NEXT_PAGE = 'ADMIN_GET_SMEV_RESEND_BY_SENDING_DATE_NEXT_PAGE',
  ADMIN_SET_SMEV_RESEND_BY_SENDING_DATE = 'ADMIN_SET_SMEV_RESEND_BY_SENDING_DATE',
  ADMIN_GET_MANAGE_TEST_USERS_LIST = 'ADMIN_GET_MANAGE_TEST_USERS_LIST',
  ADMIN_GET_MANAGE_TEST_USERS_LIST_NEXT_PAGE = 'ADMIN_GET_MANAGE_TEST_USERS_LIST_NEXT_PAGE',
  ADMIN_SET_MANAGE_TEST_USERS_LIST = 'ADMIN_SET_MANAGE_TEST_USERS_LIST',
  ADMIN_SET_MANAGE_TEST_USERS_LIST_ORDER = 'ADMIN_SET_MANAGE_TEST_USERS_LIST_ORDER',
  ADMIN_UPDATE_MANAGE_TEST_USERS_LIST = 'ADMIN_UPDATE_MANAGE_TEST_USERS_LIST',
  ADMIN_SET_USER_ADMIN_PARAMS = 'ADMIN_SET_USER_ADMIN_PARAMS',
}
